<script setup lang="ts">
import { type DialogController, sleep } from "@/vf"
import { defineComponent, ref, type RenderFunction } from "vue"

const props = defineProps<{
    controller: DialogController<void>
    content: RenderFunction
}>()

const closeButton = ref<HTMLButtonElement | null>(null)
const contentComponent = defineComponent({
    setup() {
        sleep(100).then(() => closeButton.value?.focus())
        return () => props.content()
    },
})
</script>

<template>
    <div class="dialog">
        <div class="dialog-body">
            <div>
                <contentComponent />
            </div>

            <button ref="closeButton" type="button" class="btn btn-primary mt-3" @click="controller.ok()">
                Schließen
            </button>
        </div>
    </div>
</template>
